import { bb } from "$json";
/* shout-out-resize: post message to parent on resize
 *
 *
 * Author: Niels Giesen
 * Copyright 2013, 2016, 2019, 2021 Berkeley Bridge
 *
 */
(function pluginShoutOut($, document) {
  const leeway = bb.propFinder(bb.conf, "arbitrary")(
    "shout-out-resize.leeway",
    80
  );
  const minheight = bb.propFinder(bb.conf, "arbitrary")(
    "shout-out-resize.minheight",
    100
  );
  const timeout = 200;
  let origins;

  if (top === self) {
    bb.Mode.unset("isEmbedded");
    if (typeof console != "undefined" && console && console.log) {
      console.log("Not inside iframe... backing out early");
    }
    return;
  } else {
    bb.Mode.set("isEmbedded");
  }

  if (!("postMessage" in window.parent)) {
    return;
  }
  try {
    origins = bb.conf?.arbitrary?.parentDomain || location.origin; //e.g. 'https://bridge-to-knowledge.nl';
    if (typeof origins === "string") {
      origins = [origins];
    }
  } catch (e) {
    window.console && window.console.warn(e);
    return;
  }

  function callOut(data) {
    bb.Mode.set("isNotScrolling");
    origins.forEach(function (origin) {
      window.parent.postMessage(JSON.stringify(data), origin);
    });
  }

  $(function () {
    if ("ResizeObserver" in window) {
      const ro = new ResizeObserver(function (entries) {
        const cr = entries[0].contentRect;
        let height = cr.height >= minheight ? cr.height : minheight;
        callOut({ height: height });
      });
      ro.observe(document.body);
    } else {
      const resize = () => {
        callOut({ height: $(document.body).height() + leeway });
      };

      $("body").append(
        '<iframe id="frame0" name="frame0"' +
          " width=100% height=100%" +
          ' style="border:none;position:absolute;top:0px;z-index:-1"></iframe>'
      );

      document.getElementById("frame0").onresize = function () {
        window.setTimeout(resize, timeout);
      };

      $(document).on("bb:postHandleData", resize);
      $(document).on("bb:resized", resize);
      $(document).on("bb:userError", resize);
    }
  });
})(jQuery, document);
